<script lang="ts">
    import cn from 'classnames';

    import { globalStore } from '@components/stores';

    import s from './main-wrapper.module.css';

    export let isTransparent = false;
    export let classes = '';
</script>

<main class={cn(s.main, { [s.transparent]: isTransparent, [s.desktop]: $globalStore.isDesktopSite }, classes)}>
    <slot/>
</main>
